import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { ConnectionProvider, useConnection } from "./adamo/connection";
import type { PortalConfig } from "./api/client";
import { ClerkGate, useAccount, WhoAreYou } from "./auth/account";
import { Banner } from "./components/Banner";
import { RobotPage } from "./pages/RobotPage";
import { RobotsPage } from "./pages/RobotsPage";

function Shell() {
  const { me, trouble, connecting } = useConnection();
  const { signOut } = useAccount();
  return (
    <>
      <header className="top">
        <a className="mark" href="/">operator</a>
        <span className="who">
          {me?.email}
          {signOut && <button className="link" onClick={signOut}>sign out</button>}
        </span>
      </header>
      {trouble && <Banner tone="warn">{trouble}</Banner>}
      {connecting && !trouble && <Banner tone="quiet">connecting to the relay…</Banner>}
      <main>
        <Routes>
          <Route path="/" element={<RobotsPage />} />
          <Route path="/robots/:id" element={<RobotPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </>
  );
}

function Portal() {
  return (
    <WhoAreYou>
      {(me) => (
        <ConnectionProvider me={me}>
          <Shell />
        </ConnectionProvider>
      )}
    </WhoAreYou>
  );
}

export function App({ config }: { config: PortalConfig }) {
  return (
    <BrowserRouter>
      {config.auth === "clerk" ? (
        <ClerkGate publishableKey={config.clerkPublishableKey}>
          <Portal />
        </ClerkGate>
      ) : (
        <Portal />
      )}
    </BrowserRouter>
  );
}
